import { css } from "@emotion/css";
import MuiTab from "@material-ui/core/Tab";
import { letterSpacing, lineHeight, text, themeTokens } from "@octopusdeploy/design-system-tokens";
import type { ReactNode } from "react";
import { forwardRef } from "react";
import * as React from "react";
export interface TabProps {
    label: ReactNode;
    value: string;
    disabled?: boolean;
    tabIndex?: number;
}
export const Tab = forwardRef<HTMLDivElement, TabProps>(({ label, value, disabled, tabIndex, ...props }, ref) => {
    // We need to spread the props here otherwise the tab would not navigate when clicking, MUI injects extra props from parent Tabs component so that the onChange in Tabs could be called when tab is clicked.
    return <MuiTab ref={ref} classes={{ root: tabRootStyles }} {...props} label={label} value={value} disabled={disabled} tabIndex={tabIndex}/>;
});
Tab.displayName = "Tab";
const muiTabsClasses = {
    root: "MuiTab-root",
};
const tabRootStyles = css({
    [`&.${muiTabsClasses.root}`]: {
        minWidth: "7.23rem", // Needed for DrawerWrapperLayout.
        textTransform: "none",
        font: text.body.bold.medium,
        letterSpacing: letterSpacing.wide,
        lineHeight: lineHeight.xSmall,
        "&.Mui-selected": {
            color: themeTokens.color.text.selected,
        },
    },
});
